module.exports = __webpack_public_path__ + "static/media/Icono firma centralizada.d73482e5.svg";